import { createSlice } from '@reduxjs/toolkit'

export interface SnackbarState {
  message: string
  type: string | null
  duration: number | null
  status: string | null
}

const initialState: SnackbarState = {
  message: '',
  type: null,
  duration: null,
  status: null,
}

export const snackbar = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    show(state, action: { payload: Partial<SnackbarState> }) {
      return {
        ...state,
        ...action.payload,
      }
    },
    reset(state) {
      return {
        ...state,
        message: '',
        duration: null,
        status: null,
      }
    },
  },
})
